import InactivityTimer from 'gw-portals-auth-js/utils/InactivityTimer';

// EXPORT
var provider = {
    $get: ['oAuth', 'gwLogoutWarningService', 'sessionConfig', function (oAuth, gwLogoutWarningService, sessionConfig) {
        return InactivityTimer({
            oAuthConfig: oAuth,
            logoutWarningCallback: gwLogoutWarningService.showInactivityWarning,
            inactivityIntervalMins: sessionConfig.inactivityIntervalMins,
            logoutConfirmationIntervalMins: sessionConfig.logoutConfirmationIntervalMins
        });
    }]
};

export default provider;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-auth-angular/InactivityTimerService.js
// module id = 1324
// module chunks = 0